// extracted by mini-css-extract-plugin
export default {"removeButton":"ExternalPartnersProfiles_removeButton__CqZG7","addButton":"ExternalPartnersProfiles_addButton__eJSD8"};